import { styled } from '@linaria/react';

export const Wrapper = styled.div`
	display: flex;
	flex-direction: column;
	row-gap: 4px;
	color: var(--color-white);
	pointer-events: none;
`;

export const Flex = styled.div`
	display: flex;
	justify-content: space-between;

	button {
		margin: -20px -10px -20px 0;
		padding: 0 20px;
		pointer-events: auto;
	}
`;

export const Level = styled.div`
	position: relative;
	display: flex;
	z-index: 0;
	margin-right: 12px;
	width: 52px;
	height: 52px;
	background: linear-gradient(259.11deg, #e492f3 5.63%, #4e78ee 100.37%);
	border-radius: 100%;
	box-shadow: 0px 0px 4px 0px rgba(0, 0, 0, 0.25);
	&[data-smalltext='true'] {
		&:after {
			font-size: 28px;
		}
	}
	&:after {
		content: attr(data-level);
		display: inline-block;
		margin: auto;
		width: 46px;
		padding-right: 5px;
		text-align: center;
		font-weight: 400;
		color: var(--color-white);
		font-size: 36px;
		line-height: 46px;
		letter-spacing: -4px;
		white-space: nowrap;
		background: #322b52;
		border-radius: inherit;
	}
	&:before {
		content: '';
		position: absolute;
		top: 0;
		left: 0;
		right: 0;
		bottom: 0;
		z-index: -1;
		width: 100%;
		height: 100%;
		background: linear-gradient(259.11deg, #e492f3 5.63%, #4e78ee 100.37%);
		opacity: 0;
		border: 3px solid transparent;
		border-radius: 100%;
		mask: linear-gradient(#fff 0 0) padding-box, linear-gradient(#fff 0 0);
		-webkit-mask-composite: destination-out;
		mask-composite: exclude;
	}
`;

export const Neuron = styled.div`
	position: relative;
	z-index: 0;
	margin-right: 12px;
	&:after {
		content: '';
		position: absolute;
		left: 8px;
		top: 8px;
		z-index: -1;
		height: calc(100% - 16px);
		aspect-ratio: 1 / 1;
		border-radius: 50%;
		box-shadow: 0 0 0 0 var(--brand-pink);
	}
`;

export const BurstWrapper = styled.div`
	position: relative;
	display: flex;
	flex-direction: column;
	align-items: center;
	z-index: 0;
	pointer-events: none;
`;

export const Jumbo = styled.div`
	z-index: 1;
	margin-bottom: -70px;
`;

export const BurstOuter = styled.div`
	position: relative;
	border-radius: 32px;
	z-index: -1;
	animation: glow 5s infinite, float 2s infinite;

	&::before {
		content: '';
		position: absolute;
		z-index: -1;
		width: 100%;
		height: 100%;
		background: linear-gradient(45deg, #78c4ff -150%, var(--color-white) 150%);
		opacity: 0.8;
		border-radius: 60% 40% 30% 70% / 60% 30% 70% 40%;
		transition: filter 0.2s, transform 0.3s, opacity 0.2s;
		filter: blur(6px);
		transform: scale(1.15);
		animation: liquid 3s ease-in-out;
	}

	@keyframes liquid {
		0%,
		100% {
			border-radius: 30% 60% 70% 50% / 50% 60% 30% 60%;
			background-size: 250% 150%;
		}
		33% {
			border-radius: 50% 60% 30% 60% / 30% 60% 70% 50%;
			background-size: 150% 300%;
		}
		63% {
			border-radius: 30% 60% 70% 40% / 50% 60% 30% 60%;
			background-size: 350% 250%;
		}
		86% {
			border-radius: 50% 60% 30% 60% / 30% 60% 70% 50%;
			background-size: 150% 300%;
		}
	}
	@keyframes glow {
		0% {
			box-shadow: 0 0 75px 20px var(--brand-common);
		}
	}
	@keyframes float {
		0%,
		100% {
			transform: translateY(0);
		}
		40% {
			transform: translateY(2%);
		}
	}
`;

export const BurstInner = styled.div`
	position: relative;
	padding: 80px 48px 48px;
	background: linear-gradient(
		90deg,
		var(--brand-dark) -10%,
		var(--brand-pink) 250%
	);
	border-radius: 32px;

	&::before,
	&::after {
		content: '';
		z-index: -1;
		position: absolute;
		top: 0;
		left: 0;
		width: calc(100% + 12px);
		height: calc(100% + 12px);
		margin: -6px;
		padding: 3px;
		border: 3px solid var(--brand-blue-light);
		border-radius: 32px;
	}
`;

export const BurstAmount = styled.p`
	color: var(--color-white);
	font-size: 32px;
	font-weight: 800;
	text-align: center;

	span {
		display: block;
		color: var(--brand-blue-light);
		font-size: 20px;
	}
`;

export const Flame = styled.div`
	position: relative;
	margin-right: 12px;
`;
